module.exports = __webpack_public_path__ + "static/media/Seismic_Hazard.ab312302.png";